import { isSimpleGroup } from '../objects/guards';
import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';
import Shortcut from '../utils/Shortcut';
import { inGroup } from '../utils/objects';
import type WhiteboardController from '../controllers/WhiteboardController';

class ToolDelete extends Tool {
  static toolName = 'Delete';
  static shortcut = new Shortcut('Del,Backspace');

  static deleteObjects(
    objects: fabric.Object[],
    controller: WhiteboardController
  ) {
    // due to out zManagerSort behaviour, we assume parent objects come before their children in this
    // array. To ensure we delete cleanly, and can recreate cleanly on undo, we delete in reverse order.
    objects.toReversed().forEach(obj => {
      // Called first so that objects are properly removed from the active
      // selection.
      if (obj.deleted) {
        obj.deleted(controller);
      }
      obj.fire('deleted');

      // Recursively delete objects in groups
      if (isSimpleGroup(obj)) {
        this.deleteObjects(obj._objects, controller);
      }
    });
  }

  static action({ controller }: IToolActionInput) {
    const canvas = controller.canvas;
    const activeObjects = canvas.getActiveObjects();

    canvas.discardActiveObject();
    if (activeObjects.length) {
      this.deleteObjects(activeObjects, controller);
      canvas.remove(...activeObjects);
    }
    this.toolActionComplete({ controller });
  }

  static enabled({ selection }: IToolEnabledInput): boolean {
    return !!(
      selection &&
      !inGroup(selection) &&
      !selection.locked &&
      !selection.getObjects().some(obj => obj.locked)
    );
  }
}

export default ToolDelete;
